import React from 'react';
import { Button, List } from 'antd';
import classnames from 'classnames';

import styles from '../../styles.module.scss';

export const UserRender = ({ name, email, onEdit, onDelete, className }) => (
  <List.Item
    className={classnames(styles.user, className)}
    actions={[
      <Button
        onClick={onEdit}
        icon="edit"
        size="small"
      />,
      <Button
        onClick={onDelete}
        icon="delete"
        size="small"
        type="danger"
      />,
    ]}
  >
    <div>
      <p
        className={styles.user__name}
      >
        {name}
      </p>
      <p
        className={styles.user__email}
      >
        {email}
      </p>
    </div>
  </List.Item>
);

export default UserRender;



// WEBPACK FOOTER //
// ./src/components/Admin/UsersManagement/UsersList/User/render.js